var render = function () {
  var _vm$data, _vm$data$review, _vm$data$review2, _vm$data$review3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-statistics"
  }, [_c('nuxt-link', {
    staticClass: "product-statistics__item",
    attrs: {
      "to": ((_vm.link) + "review/")
    }
  }, [_c('div', {
    staticClass: "product-statistics__top"
  }, [_c('div', {
    staticClass: "product-statistics__icon product-statistics__review-icon",
    class: {
      'product-statistics__review-icon_active': (_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : (_vm$data$review = _vm$data.review) === null || _vm$data$review === void 0 ? void 0 : _vm$data$review.reviewCount
    }
  }), _vm._v(" "), (_vm$data$review2 = _vm.data.review) !== null && _vm$data$review2 !== void 0 && _vm$data$review2.average ? _c('span', {
    staticClass: "product-statistics__value"
  }, [_vm._v("\n        " + _vm._s((_vm$data$review3 = _vm.data.review) === null || _vm$data$review3 === void 0 ? void 0 : _vm$data$review3.average) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "product-statistics__descriptions"
  }, [_vm._v("\n      " + _vm._s(_vm.getRateStatus) + "\n    ")])]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "product-statistics__item",
    attrs: {
      "to": ((_vm.link) + "question/")
    }
  }, [_c('div', {
    staticClass: "product-statistics__top"
  }, [_c('div', {
    staticClass: "product-statistics__icon  product-statistics__question-icon"
  }), _vm._v(" "), _vm.data.questionCount ? _c('span', {
    staticClass: "product-statistics__value"
  }, [_vm._v("\n        " + _vm._s(_vm.data.questionCount) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "product-statistics__descriptions"
  }, [_vm._v("\n      " + _vm._s(_vm.convertQuestionText || 'спросить') + "\n    ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }